var requests = {}

const loadScript = function(src, opts, cb) {
  
  let head = document.head || document.getElementsByTagName("head")[0]
  let script = document.createElement("script")


  opts = opts || {}
  cb = cb || function() {}

  script.type = "text/javascript"
  script.charset = "utf8"
  script.src = src

  if (opts) {
    for (var attr in opts) {
      script.setAttribute(attr, opts[attr])
    }
  }
  

  let onend = "onload" in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  if (!script.onload) {
    stdOnEnd(script, cb)
  }

  head.appendChild(script)
}


const stdOnEnd = function(script, cb) {
  script.onload = function() {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function() {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error("Failed to load " + this.src), script)
  }
}

const ieOnEnd = function(script, cb) {
  script.onreadystatechange = function() {
    if (this.readyState !== "complete" && this.readyState !== "loaded") return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}

const getGlobal = function(key) {
  if (window[key]) {
    return window[key]
  }
  if (window.exports && window.exports[key]) {
    return window.exports[key]
  }
  if (window.module && window.module.exports && window.module.exports[key]) {
    return window.module.exports[key]
  }
  return null
}

const loadExternalLibrary = function({url, name, attributes}) {
  var isLoaded = () => true
  var libReady = null;
  const existingGlobal = getGlobal(name)
  if (existingGlobal && isLoaded(existingGlobal)) {
    return Promise.resolve(existingGlobal)
  }
  return new Promise((resolve, reject) => {
    // If we are already loading the SDK, add the resolve and reject
    // functions to the existing array of requests
    if (requests[url]) {
      requests[url].push({ resolve, reject })
      return
    }
    requests[url] = [{ resolve, reject }]
    const onLoaded = sdk => {
      // When loaded, resolve all pending request promises
      requests[url].forEach(request => request.resolve(sdk))
    }
    if (libReady) {
      const previousOnReady = window[libReady]
      window[libReady] = function() {
        if (previousOnReady) previousOnReady()
        onLoaded(getGlobal(name))
      }
    }
    loadScript(url, attributes, err => {
      if (err) {
        console.warn(`Error loading external JS lib: ${url}. ${err}`)
        // Loading the SDK failed – reject all requests and
        // reset the array of requests for this SDK
        requests[url].forEach(request => request.reject(err))
        requests[url] = null
      } else if (!libReady) {
        onLoaded(getGlobal(name))
      }
    })
  })
}
export default loadExternalLibrary
